export default "__VITE_ASSET__f21df349__"